var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel"},[_c('Bread',_vm._b({},'Bread',_vm.bread,false)),_c('Info'),_c('Ship'),(!_vm.isQilinYun)?_c('Boss'):_vm._e(),_c('Erp'),_c('Fbb')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }